import styled from "styled-components";

//STYLES
const Item = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 10px;
    border-right: thin solid rgba(0,0,0,0.06);
    color: var(--text-color);

    :is([data-sorting = true]) {
        background: #fafafa;
    }

`;

//PROPS
interface Props {
    style?: React.CSSProperties;
    children?: React.ReactNode;
    width?: number | string;
    gap?: number;
    fontSize?: number;
    onClick?: Function;
    sorting?: boolean;
    nowrap?: boolean;
}

export const RowItem: React.FC<Props> = ({ children, width, gap, fontSize, onClick, nowrap, sorting, style }) => {
    
    return (
        <Item 
            style={{ 
                ...style,
                width: width, 
                minWidth: width, 
                gap: gap, 
                fontSize: fontSize,
            }} 
            data-sorting={sorting} 
            onClick={()=>{onClick?.()}}
        >
            <span style={{
                display: 'flex',
                justifyContent: 'flex-start',
                margin: 0,
                overflow: nowrap ? 'hidden' : undefined,
                textOverflow: nowrap ? 'ellipsis' : undefined,
                whiteSpace: nowrap ? 'nowrap' : undefined,
                gap: gap,
                ...style
            }}
            >
                {children}
            </span>
        </Item>
    )
}